export const ADMIN_AUTH_STATUS = {
  IDLE: 'idle',
  CHECKING: 'checking',
  AUTHENTICATED: 'authenticated',
  ANONYMOUS: 'anonymous',
  ENROLLMENT_REQUIRED: 'enrollment_required',
}

export const ALLOWED_ADMIN_ROLES = ['admin', 'superadmin', 'curator', 'collaborator']

export const isAllowedAdminRole = (role) =>
  ALLOWED_ADMIN_ROLES.includes(
    String(role || '')
      .trim()
      .toLowerCase(),
  )

export const requiresAdminEnrollment = (user) => {
  return user?.authSecurity?.requiresMfaEnrollment === true
}
